/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import { makeStyles } from '@material-ui/core';

// eslint-disable-next-line import/prefer-default-export
export const useStyles = makeStyles((theme) => ({
    root: {
        width: 58,
        height: 28,
        padding: 0,
    },
    switchBase: {
        padding: 4,
        '&$checked': {
            transform: 'translateX(30px)',
            color: theme.palette.common.white,
            '& + $track': {
                backgroundColor: '#F3E6F4',
                opacity: 1,
                border: 'none',
            },
        },
    },
    thumb: {
        width: 20,
        height: 20,
    },
    track: {
        borderRadius: 26 / 2,
        backgroundColor: '#C4C4C4',
        opacity: 1,
        transition: theme.transitions.create(['background-color', 'border']),
    },

    // Don't remove this empty class.
    checked: {},

    switchRoot: {
        display: 'flex',
        position: 'relative',
        alignItems: 'center',
        cursor: 'pointer',
        top: -2,
    },
    label: {
        fontSize: '0.75rem !important',
        position: 'absolute',
        zIndex: 1,
        color: '#000000',
        userSelect: 'none',
        pointerEvents: 'none',
        margin: 0,
    },
    left: {
        left: 8,
        top: 4,
    },
    right: {
        left: 27,
        top: 4,
    },
}));
